import { render, staticRenderFns } from "./ArtDetails.vue?vue&type=template&id=fa261396&"
import script from "./ArtDetails.vue?vue&type=script&lang=js&"
export * from "./ArtDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArtDetails.vue?vue&type=style&index=0&id=fa261396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports